/* eslint-disable no-unused-vars */
/* eslint-disable object-shorthand */
/* eslint-disable import/order */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-plusplus */
/* eslint-disable no-lonely-if */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { repriceCabsApi, searchCabsApi } from '../../../api/cabApi';
import CabsSearch from '../landing/CabsSearch';
import './CabSearchResults.scss';
import CabResultCard from './CabResultCard';
import { Col, Row } from 'react-bootstrap';
import CabFilters from './CabFilters';
import { debounce } from '../../../api/apiUtils';
import { NAVIGATION_ROUTES } from '../../../shared/constants/Constants';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import AppAlert from '../../../shared/components/app-alert/AppAlert';

function CabSearchResults() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [searchRequest, setSearchRequest] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const [vehiclenames, setVehiclenames] = useState([]);
  const [servicetypes, setServicetypes] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    selectedMinPrice: 0,
    selectedMaxPrice: 0,
    vechicleName: [],
    serviceType: [],
  });
  const allResultsRef = useRef(null);
  const [searchResponseId, setSerchResponseId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);

  const getCabSearchResults = async (searchObj) => {
    setIsLoading(true);
    const response = await searchCabsApi(searchObj);
    if (response.statusCode === 200) {
      const cabs = response.transferInfoList.sort(
        (a, b) => a.nextraTotalPrice - b.nextraTotalPrice,
      );
      const vechicleNames = [];
      const serviceTypes = [];
      cabs.forEach((cab) => {
        if (!vechicleNames.includes(cab.vehicleDetails.name)) {
          vechicleNames.push(cab.vehicleDetails.name);
        }
        if (!serviceTypes.includes(cab.vehicleDetails.serviceType)) {
          serviceTypes.push(cab.vehicleDetails.serviceType);
        }
      });
      setSerchResponseId(response.serachResponseId);
      setVehiclenames(vechicleNames);
      setServicetypes(serviceTypes);
      setMinPrice(cabs[0].nextraTotalPrice);
      setMaxPrice(cabs[cabs.length - 1].nextraTotalPrice);
      setSearchResults(cabs);
      allResultsRef.current = cabs;
    } else {
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const currentParams = Object.fromEntries([...searchParams]);
    const searchObj = {};

    Object.entries(currentParams).forEach(([key, value]) => {
      if (!key.includes('[')) {
        if (['adults', 'childs', 'infants'].includes(key)) {
          searchObj[key] = Number(value);
        } else {
          searchObj[key] = value;
        }
        return;
      }
      const parts = key.replaceAll(']', '').split('['); // e.g., pickup[lat] => ['pickup', 'lat']
      let current = searchObj;
      parts.forEach((part, idx) => {
        if (idx === parts.length - 1) {
          if (['lat', 'lng', 'adults', 'childs', 'infants'].includes(part)) {
            current[part] = Number(value);
          } else {
            // ✅ handle empty array like childAges[]
            if (part === '' && value === '') {
              const arrKey = parts[parts.length - 2];

              // instead of setting on `current`, set on its parent
              let parent = searchObj;
              for (let i = 0; i < idx - 1; i++) {
                parent = parent[parts[i]];
              }
              parent[arrKey] = [];
            } else {
              current[part] = value;
            }
          }
        } else {
          if (!current[part]) {
            // if next is a number, use array; otherwise object
            const nextPart = parts[idx + 1];
            current[part] = /^\d+$/.test(nextPart) ? [] : {};
          }
          current = current[part];
        }
      });
    });
    setSearchRequest(searchObj);
    getCabSearchResults(searchObj);
  }, [searchParams]);

  const handleApplyFilter = debounce((filters) => {
    setSelectedFilters(filters);
    if (filters) {
      const cabs = [...allResultsRef.current];
      const filteredResults = cabs.filter((cab) => {
        return (
          (filters.selectedMinPrice > 0
            ? cab.nextraTotalPrice >= filters.selectedMinPrice
            : true) &&
          (filters.selectedMaxPrice > 0
            ? cab.nextraTotalPrice <= filters.selectedMaxPrice
            : true) &&
          (filters.selectedVechicleName.length > 0
            ? filters.selectedVechicleName.includes(cab.vehicleDetails.name)
            : true) &&
          (filters.selectedServiceType.length > 0
            ? filters.selectedServiceType.includes(
                cab.vehicleDetails.serviceType,
              )
            : true)
        );
      });

      setSearchResults(filteredResults);
    }
  }, 500);

  const handleapplyClearFilter = () => {
    setSelectedFilters({
      selectedMinPrice: minPrice,
      selectedMaxPrice: maxPrice,
      vechicleName: [],
      serviceType: [],
    });
    setSearchResults(allResultsRef.current);
  };
  const handleBook = async (cab) => {
    const request = {
      faresource: cab.fareSource,
      searchResponseId: searchResponseId,
      nextratotalprice: cab.nextraTotalPrice,
      selectedVechicals: [{ bookingKey: cab.vehicleBookingKey }],
    };
    const response = await repriceCabsApi(request);
    setIsLoading(true);
    if (response.statusCode === 200) {
      navigate(NAVIGATION_ROUTES.CABS.REVIEW_BOOKING, {
        state: { searchRequest, repriceResponse: response },
      });
    } else {
      setAlert({
        variant: 'error',
        title: 'Error',
        description: response.message,
      });
    }
    setIsLoading(false);
  };
  return (
    <div className="cab-search-results-page">
      {isLoading && <AppLoading isLoading={isLoading} />}
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => {
            setAlert(undefined);
          }}
        />
      )}
      {searchRequest && (
        <div>
          <div className="cab-modify-search">
            <div className="container p-2">
              <CabsSearch
                previousSearchRequest={searchRequest}
                isModifySearch={true}
              />
            </div>
          </div>
          <Row className="cab-search-results-container">
            {searchResults?.length > 0 ? (
              <>
                <Col lg={3} md={3} sm={3} xs={12} className="mt-2">
                  <CabFilters
                    minPrice={minPrice}
                    maxPrice={maxPrice}
                    selectedFilters={selectedFilters}
                    vehicleNames={vehiclenames}
                    serviceTypes={servicetypes}
                    onApplyFilter={handleApplyFilter}
                    onClearFilters={handleapplyClearFilter}
                  />
                </Col>

                <Col lg={9} md={12} sm={12} xs={12}>
                  <div className="container p-2">
                    {searchResults.map((cab) => (
                      <CabResultCard
                        key={cab.vehicleBookingKey}
                        cab={cab}
                        onBook={handleBook}
                      />
                    ))}
                  </div>
                </Col>
              </>
            ) : (
              <Col lg={9} md={12} sm={12} xs={12}>
                <div>No search results found.</div>
              </Col>
            )}
          </Row>
        </div>
      )}
    </div>
  );
}

export default CabSearchResults;
